/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Icon, Tooltip } from '@chakra-ui/react';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

interface SortButtonProps {
  sortOrder?: 'asc' | 'desc' | null;
  onSortChange: (order: 'asc' | 'desc' | null) => void;
  label: string;
  tooltip?: {
    none: string;
    asc: string;
    desc: string;
  };
  size?: 'sm' | 'md' | 'lg';
}

export const SortButton: React.FC<SortButtonProps> = ({
  sortOrder,
  onSortChange,
  label,
  tooltip = {
    none: 'Clique para ordenar',
    asc: 'Ordenação crescente',
    desc: 'Ordenação decrescente'
  },
  size = 'md'
}) => {
  const getNextSortOrder = () => {
    if (sortOrder === null) return 'asc';
    if (sortOrder === 'asc') return 'desc';
    return null;
  };

  const getIcon = () => {
    if (sortOrder === null) return FaSort;
    if (sortOrder === 'asc') return FaSortUp;
    return FaSortDown;
  };

  const getTooltipText = () => {
    if (sortOrder === null) return tooltip.none;
    if (sortOrder === 'asc') return tooltip.asc;
    return tooltip.desc;
  };

  const getSizeProps = () => {
    switch (size) {
      case 'sm':
        return { w: '16px', h: '16px', iconSize: '8px' };
      case 'lg':
        return { w: '24px', h: '24px', iconSize: '12px' };
      default:
        return { w: '20px', h: '20px', iconSize: '10px' };
    }
  };

  const sizeProps = getSizeProps();

  return (
    <Tooltip label={getTooltipText()} placement="top">
      <Box
        as="button"
        onClick={() => onSortChange(getNextSortOrder())}
        display="flex"
        alignItems="center"
        justifyContent="center"
        w={sizeProps.w}
        h={sizeProps.h}
        minW={sizeProps.w}
        maxW={sizeProps.w}
        minH={sizeProps.h}
        maxH={sizeProps.h}
        borderRadius="md"
        bg={sortOrder ? 'blue.50' : 'gray.50'}
        border="1px solid"
        borderColor={sortOrder ? 'blue.200' : 'gray.200'}
        color={sortOrder ? 'blue.600' : 'gray.400'}
        cursor="pointer"
        _hover={{
          bg: sortOrder ? 'blue.100' : 'gray.100',
          borderColor: sortOrder ? 'blue.300' : 'gray.300',
          transform: 'translateY(-1px)',
          boxShadow: 'sm'
        }}
        _active={{
          transform: 'translateY(0)',
          boxShadow: 'none'
        }}
        transition="all 0.2s ease"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bg: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
          opacity: sortOrder ? 1 : 0,
          transition: 'opacity 0.2s ease'
        }}
      >
        <Icon
          as={getIcon()}
          boxSize={sizeProps.iconSize}
          zIndex={1}
          position="relative"
        />
      </Box>
    </Tooltip>
  );
};

export default SortButton;
